import dayjs from 'dayjs';
import PropTypes from 'prop-types';
import React, {
    useEffect,
    useState,
} from 'react';

// import { getCalendarMonthMatrix } from '../Utils/getCalendarMonthMatrix';

const CraRdvContext = React.createContext({
    // monthCalendarIndex: 0,
    // setMonthCalendarIndex: () => { },
    // setDaySelected: () => { },
    // setGetsEvents: () => { },
    // showEventModal: false,
    // setShowEventModal: () => { },
    // savedEvents: [],
    // selectedEvent: null,
    // setSelectedEvent: () => { },
    // smallCalendarMonth: 0,
    // setSmallCalendarMonth: () => { },
    // selectedDay: null,
    // setSelectedDay: () => { },
    // showRDV: false,
    // setShowRDV: () => { },
    // selectedRDV: null,
    // setSelectedRDV: () => { },
});

export function CraRdvProvider(props) {
    CraRdvProvider.propTypes = {
        children: PropTypes.any,
        onClickOut: PropTypes.func,
    };
    const [monthCalendarIndex, setMonthCalendarIndex] = useState(dayjs().month());
    const [calendarMonthMatrix,setCalendarMonthMatrix] = useState([[]]);
    const [daySelected, setDaySelected] = useState(dayjs());
    const [showEventModal, setShowEventModal] = useState(false);
    const [selectedEvent, setSelectedEvent] = useState(null);
    const [smallCalendarMonth, setSmallCalendarMonth] = useState(null);
    const [selectedDay, setSelectedDay] = useState(dayjs());
    const [showRDV, setShowRDV] = useState(false);
    const [selectedRDV, setSelectedRDV] = useState(null);
    const [openNestedInterviewerCandidature, setOpenNestedInterviewerCandidature] = useState(false);
    // * AO drafts
    const [selectedAO, setSelectedAO] = useState(null);

    // * ExpertToBeCreated
    const [expertToBeCreated, setExpertToBeCreated] = useState(null);

    // //* Material-table : same performance problem as putting the state inside the reusable component, so I must put the state in each call of muiTable :)
    const [selectedRow, setSelectedRow] = React.useState(null);

    //Cv cvtheque client
    const [ListStatutCv, setListStatutCv] = useState([]);

    useEffect(() => {
        if (!showEventModal) {
            setSelectedEvent(null);
        }
    }, [showEventModal]);

    useEffect(() => {
        if (smallCalendarMonth !== null) {
            monthCalendarIndex(smallCalendarMonth);
        }
    }, [smallCalendarMonth]);

    // * I removed this since I need it inside the dialog of rdv
    // useEffect(() => {
    //     if (!showRDV) {
    //         setSelectedRDV(null);
    //     }
    // }, [showRDV]);

    return (
        <CraRdvContext.Provider
            value={{
                monthCalendarIndex,setMonthCalendarIndex,
                daySelected,setDaySelected,
                showEventModal,setShowEventModal,
                selectedEvent,setSelectedEvent,
                smallCalendarMonth, setSmallCalendarMonth,
                selectedDay, setSelectedDay,
                showRDV, setShowRDV,
                selectedRDV, setSelectedRDV,
                calendarMonthMatrix,setCalendarMonthMatrix,
                openNestedInterviewerCandidature, setOpenNestedInterviewerCandidature,
                selectedAO, setSelectedAO,
                expertToBeCreated, setExpertToBeCreated,
                selectedRow, setSelectedRow,
                ListStatutCv, setListStatutCv

            }}
        >
            {props.children}
        </CraRdvContext.Provider>
    );
}

export default CraRdvContext;